import { salePages } from '../../salePages';

export const SALE_MACRO_STEPS = [
  { key: 'orderDetails', label: 'פרטי הזמנה' },
  { key: 'installation', label: 'תיאום התקנה' },
  { key: 'payment', label: 'תשלום' },
];

export const EMPTY_STEP_BAR = {
  show: false,
  steps: SALE_MACRO_STEPS.map((step) => ({
    ...step,
    status: 'pending',
    fillPercent: 0,
  })),
};

export const SALE_STEP_PAGE_CONFIG = {
  premiumPackagesPage: { macroStep: 'orderDetails', showStepBar: true },
  convertersPage: { macroStep: 'orderDetails', showStepBar: true },
  addonsPage: { macroStep: 'orderDetails', showStepBar: true },
  internetCustomerInfoPage: { macroStep: 'orderDetails', showStepBar: true, fillPercent: 100 },
  internetPaymentDigitsPage: { macroStep: 'orderDetails', showStepBar: true, fillPercent: 100 },
  technicianPage: { macroStep: 'installation', showStepBar: true },
  deliveryAddressPage: { macroStep: 'installation', showStepBar: true },
  deliveryPage: { macroStep: 'installation', showStepBar: true },
  personalInfoPage: { macroStep: 'payment', showStepBar: true },
  userAddressPage: { macroStep: 'payment', showStepBar: true },
  internetExistingPaymentPage: { macroStep: 'payment', showStepBar: true, fillPercent: 100 },
  emailPage: { macroStep: 'payment', showStepBar: true },
  summaryPage: { macroStep: 'payment', showStepBar: true },
  paymentPage: { macroStep: 'payment', showStepBar: true },
  successPage: { macroStep: 'payment', showStepBar: true },
};

export const isStepBarPage = (pageName) =>
  Boolean(SALE_STEP_PAGE_CONFIG[pageName]?.showStepBar);

const getPageStepConfig = (pageName, salePageEntry) => ({
  macroStep: salePageEntry?.macroStep ?? SALE_STEP_PAGE_CONFIG[pageName]?.macroStep,
  showStepBar: salePageEntry?.showStepBar ?? SALE_STEP_PAGE_CONFIG[pageName]?.showStepBar ?? false,
  percent: salePageEntry?.percent ?? SALE_STEP_PAGE_CONFIG[pageName]?.percent,
  fillPercent: salePageEntry?.fillPercent ?? SALE_STEP_PAGE_CONFIG[pageName]?.fillPercent,
});

const getMacroStep = (pageName, salePageEntry) => getPageStepConfig(pageName, salePageEntry).macroStep;

const getStepPagesForFlow = (stepKey, flowPageNames) => {
  const pagesInStep = flowPageNames.filter(
    (pageName) => getMacroStep(pageName, null) === stepKey,
  );

  if (stepKey === 'orderDetails') {
    ['addonsPage', 'internetCustomerInfoPage', 'internetPaymentDigitsPage', 'createSaleInProcess'].forEach((pageName) => {
      if (!pagesInStep.includes(pageName)) {
        pagesInStep.push(pageName);
      }
    });
  }

  return pagesInStep;
};

export const buildStepBarState = (saleType, flowType, currentPage) => {
  const flowEntries = salePages[saleType]?.[flowType] || [];
  const flowPageNames = flowEntries.map((item) => item.page);
  const salePageEntry = flowEntries.find((item) => item.page === currentPage);
  let pageConfig = getPageStepConfig(currentPage, salePageEntry);

  if (currentPage === 'otpVerifyCode' && saleType === 'internet') {
    pageConfig = {
      ...pageConfig,
      macroStep: 'orderDetails',
      showStepBar: true,
      fillPercent: 100,
    };
  }

  if (!pageConfig.showStepBar) {
    return {
      show: false,
      steps: EMPTY_STEP_BAR.steps.map((step) => ({ ...step })),
    };
  }

  const currentStepKey = pageConfig.macroStep || 'orderDetails';
  const activeStepIndex = SALE_MACRO_STEPS.findIndex((step) => step.key === currentStepKey);

  const steps = SALE_MACRO_STEPS.map((step, index) => {
    if (index < activeStepIndex) {
      return { ...step, status: 'completed', fillPercent: 100 };
    }

    if (index > activeStepIndex) {
      return { ...step, status: 'pending', fillPercent: 0 };
    }

    const stepPages = getStepPagesForFlow(step.key, flowPageNames);
    const pageIndex = stepPages.indexOf(currentPage);
    const fillPercent = pageConfig.fillPercent != null
      ? pageConfig.fillPercent
      : pageIndex >= 0
        ? Math.round(((pageIndex + 1) / stepPages.length) * 100)
        : 50;

    return { ...step, status: 'active', fillPercent };
  });

  return { show: true, steps };
};

export const applyPageNavigationState = (state, pageName) => {
  console.log('[SaleStepBar] navigated to page:', pageName);
  const saleType = state.saleType;
  const flowType = state.flowType || 'newCustomer';
  const flowEntries = salePages[saleType]?.[flowType] || [];
  const salePageEntry = flowEntries.find((item) => item.page === pageName);
  const pageConfig = getPageStepConfig(pageName, salePageEntry);

  if (pageConfig.percent != null) {
    state.percent = pageConfig.percent;
  }

  state.stepBar = buildStepBarState(saleType, flowType, pageName);

  if (pageName === 'technicianPage' && state.isOccupiedTechnicianSlot) {
    state.stepBar = {
      ...state.stepBar,
      steps: state.stepBar.steps.map((step) => {
        if (step.key === 'payment') {
          return { ...step, status: 'completed', fillPercent: 100 };
        }
        return step;
      }),
    };
  }
};
